import { Component } from '@grafikr/components'
import shopifyCart from 'utils/cart'

export default Component((node) => {
  const giftVariantId = node.dataset.gift
  const giftText = node.dataset.giftText
  const giftGoal = Number(node.dataset.goal)

  const gwpPrompt = document.querySelector('[data-gwp-prompt]')
  const hasMultipleVariants = !!(window.theme.gwp_variants && window.theme.gwp_variants.length > 1)

  let ifGiftProductInCart

  function showPrompt(show) {
    if (!gwpPrompt || !hasMultipleVariants) return
    gwpPrompt.classList.toggle('visually-hidden', !show)
  }

  async function checkAndAct(cartData) {
    if (window.theme.gwpSwapInProgress) return

    const { data: cart } = await shopifyCart.get()
    if (cart?.items) {
      ifGiftProductInCart = cart.items.find((item) => item.properties?.GWP)
    }

    if (ifGiftProductInCart && Object.keys(ifGiftProductInCart).length !== 0) {
      showPrompt(false)
      return
    }

    let eligible = false

    if (window.theme.gwp_eligible_collection) {
      const eligibleProducts = await fetch(`${theme.routes.cart}?view=gwp`).then((res) => res.json())

      if (eligibleProducts.length > 0) {
        const eligibleProductsPrice = eligibleProducts
          .map((product) => product.final_line_price / 100)
          .reduce((a, b) => a + b, 0)

        eligible = eligibleProductsPrice > giftGoal
      }
    } else {
      const cartPrice = (cartData?.total_price || 0) / 100
      eligible = cartPrice > giftGoal
    }

    if (!eligible) {
      showPrompt(false)
      return
    }

    if (hasMultipleVariants) {
      showPrompt(true)
      return
    }

    // Single variant: auto-add
    document.dispatchEvent(new CustomEvent('cart:updating'))

    const fd = new FormData()
    fd.append('items[0][id]', giftVariantId)
    fd.append('items[0][quantity]', '1')
    fd.append('items[0][properties][GWP]', giftText)

    const { error } = await shopifyCart.add(fd)
    if (error) {
      console.error('GWP add error:', error)
      return
    }

    const { data: updatedCart } = await shopifyCart.get()
    if (updatedCart) {
      window.theme.cart = updatedCart
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: updatedCart }))
    }
  }

  // Handle Add button click
  if (gwpPrompt) {
    const addBtn = gwpPrompt.querySelector('.js-gwp-prompt-add')
    const select = gwpPrompt.querySelector('.js-gwp-prompt-select')

    if (addBtn) {
      addBtn.addEventListener('click', async () => {
        const variantId = select ? select.value : giftVariantId
        addBtn.disabled = true

        const fd = new FormData()
        fd.append('items[0][id]', variantId)
        fd.append('items[0][quantity]', '1')
        fd.append('items[0][properties][GWP]', giftText)

        document.dispatchEvent(new CustomEvent('cart:updating'))

        const { error } = await shopifyCart.add(fd)
        if (error) {
          console.error('GWP add error:', error)
          addBtn.disabled = false
          return
        }

        const { data: cart } = await shopifyCart.get()
        if (cart) {
          window.theme.cart = cart
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }))
        }

        addBtn.disabled = false
      })
    }
  }

  document.addEventListener('cart:updated', function (e) {
    const data = e.detail?.cart || e.detail
    checkAndAct(data)
  })

  if (theme.cart) checkAndAct(theme.cart)
})
